module.exports = __webpack_public_path__ + "static/media/Segment3.2d5c1028.jpg";